import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { BookingDetail as LegacyBookingDetail } from '../Legacy/BookingDetail';

import { BookingDetails as ModernBookingDetails } from './_components/BookingDetails/BookingDetails';

type BookingDetailsRouterProps = {
  bookingCode?: string;
  onClose: () => void;
  isLegacyBooking?: boolean;
};

export const BookingDetailsRouter = ({
  bookingCode,
  isLegacyBooking,
  onClose,
}: BookingDetailsRouterProps) => {
  const location = useLocation();
  const [scrollVCC, setScrollVCC] = useState(false);

  useEffect(() => {
    if (document.readyState === 'complete' && isLegacyBooking) {
      const query = new URLSearchParams(location.search);
      const valueVCC = query.get('bookingVCC');

      if (valueVCC) {
        setScrollVCC(true);

        const element = document.getElementById('virtual-card');

        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  }, [location.search, isLegacyBooking]);

  return isLegacyBooking ? (
    <LegacyBookingDetail
      bookingCode={bookingCode}
      onClose={onClose}
      scrollVCC={scrollVCC}
    />
  ) : (
    <ModernBookingDetails bookingCode={bookingCode} onClose={onClose} />
  );
};
